window.document.addEventListener("click", (e) => {
  if (e.target.classList.contains("mini-cart__gift-header") || e.target.closest(".mini-cart__gift-header")) {
    const panel = e.target
      .closest(".content_padding_giftCart")
      .querySelector(".panel");
    const iconDropdownArrow = document.querySelector("#icon-dropdown-arrow");
    if (panel.classList.contains("activePanel")) {
      iconDropdownArrow.classList.remove("activeIconArrow");
      panel.classList.remove("activePanel");
      iconDropdownArrow.classList.add("desactiveIconArrow");
      panel.classList.add("desactivePanel");
    } else {
      panel.classList.remove("desactivePanel");
      iconDropdownArrow.classList.remove("desactiveIconArrow");
      panel.classList.add("activePanel");
      iconDropdownArrow.classList.add("activeIconArrow");
    }
  }
});

window.document.addEventListener("change", (e) => {
  if (
    e.target.id &&
    (e.target.id === "wrap-message" || e.target.id === "wrap-author")
  ) {
    const formData = new FormData();
    const messageInput = window.document.getElementById("wrap-message");
    const authorInput = window.document.getElementById("wrap-author");
    formData.append("attributes[gift_message]", messageInput.value);
    formData.append("attributes[gift_signature]", authorInput.value);
    fetch("/cart/update.js", {
      method: "POST",
      body: formData,
    });
  } else if (e.target.id && e.target.id === "checkBoxOne") {
    const checkbox = window.document.getElementById("checkBoxOne");
    const variantId = checkbox?.dataset.variantId;
    let updates = {};
    updates[variantId] = checkbox.checked ? 1 : 0;

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates })
    }).then(() => {
      const quickCartSection = window.Shopify.theme.sections.instances.filter(
        (instance) => instance.id == "quick-cart"
      );
      quickCartSection[0].refreshQuickCart();
    });
  }
});